export default __webpack_public_path__ + "static/media/06_tag_beach.6617bfec.svg";